import { render, staticRenderFns } from "./ListRoomCategory.vue?vue&type=template&id=006a4417"
import script from "./ListRoomCategory.vue?vue&type=script&lang=js"
export * from "./ListRoomCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports